import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './_actionTypes';
import actions from './_actions';
import StudentNotificationHelper from '../../../../utils/API/BackendHelper/student/notifications';


function* fetchStudentNotificationsSaga(action) {
try {
const params = action.payload || {};
const response = yield call(StudentNotificationHelper.getCourseNotifications, params);
// assume response has shape { success, data }
if (response && response.success) {
yield put({ type: types.FETCH_STUDENT_NOTIFICATIONS_SUCCESS, payload: response.data });
} else {
yield put({ type: types.FETCH_STUDENT_NOTIFICATIONS_FAILURE, payload: response?.message || 'Failed to fetch notifications' });
}
} catch (error) {
yield put({ type: types.FETCH_STUDENT_NOTIFICATIONS_FAILURE, payload: error.message || error });
}
}


export default function* studentNotificationsSaga() {
yield takeLatest(types.FETCH_STUDENT_NOTIFICATIONS_REQUEST, fetchStudentNotificationsSaga);
}